/*
 *   File : searchInput.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : Input box
 *   Integrations : null
 *   Version : 1.0.0
 *   Created : 19-12-2021
 */
/*import package*/
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';

/*import style*/
import styles from '../../styles/components/searchInput.module.scss';

const SearchInput = (props) => {
	//eslint-disable-next-line
	const [value, setValue] = useState("");

	const inputRef = useRef(null);

	useLayoutEffect(() => {
		const timer = setTimeout(() => {
			if (inputRef.current) {
				inputRef.current.focus();
				console.log("Input focused:", inputRef.current.id || "no-id");
			} else {
				console.log("Input not yet mounted");
			}
		}, 100); // small delay ensures it's in the DOM
		return () => clearTimeout(timer);
	}, []);

	/* --- on change pass value ----*/
	const valueChange = (e) => {
		setValue(e.target.value);
		props.valueChange(e.target.value);
	}

	/* ---- pass value on press of enter ---*/
	const keyPress = (e) => {
		if (e.keyCode === 13) {
			if (props.onSearch) {
				props.onSearch(e.target.value);
			}
		}
	}

	return (
		<div className={`${styles.e_input_wrap} ${props.wrapperClass}`}>
			<input id={props.id}
				ref={inputRef}
				value={props.value}
				type={props.type}
				autoComplete='off'
				//eslint-disable-next-line
				className={`${styles.e_search_input_box}` + " " + props.className}
				onChange={(e) => { valueChange(e) }}
				placeholder={props.placeholder}
				onKeyDown={e => keyPress(e)}
				{...props} />
		</div>
	);
}
export default SearchInput;


